export function getEntrepreneursLink() {
  return "/admin/emprendedores";
}
